/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import Lightbox from "react-awesome-lightbox";
import MultiSelect from "react-multi-select-component";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

export default function Catalog(props) {
  const [isOpen, setImage] = useState(false);
  const _rows = props.rows.sort((a, b) => a.no - b.no);

  const pos_map = _rows.map((key) => key.pos);
  const pos_unique = [...new Set(pos_map)];
  const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
  const [pos_selected, pos_setSelected] = useState([]);

  const round_map = _rows.map((key) => key.round);
  const round_unique = [...new Set(round_map)];
  const round_options = round_unique.map((key) => ({ label: key, value: key }));
  const [round_selected, round_setSelected] = useState([]);

  const product_map = _rows.map((key) => key.product);
  const product_unique = [...new Set(product_map)];
  const product_options = product_unique.map((key) => ({
    label: key,
    value: key,
  }));
  const [product_selected, product_setSelected] = useState([]);

  const agent_map = _rows.map((key) => key.agent);
  const agent_unique = [...new Set(agent_map)];
  const agent_options = agent_unique.map((key) => ({ label: key, value: key }));
  const [agent_selected, agent_setSelected] = useState([]);

  const task_map = _rows.map((key) => key.task);
  const task_unique = [...new Set(task_map)];
  const task_options = task_unique.map((key) => ({ label: key.toUpperCase(), value: key }));
  const [task_selected, task_setSelected] = useState([]);

  useEffect(() => {
    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
    pos_setSelected(pos_options);
    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({
      label: key,
      value: key,
    }));
    round_setSelected(round_options);
    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique.map((key) => ({
      label: key,
      value: key,
    }));
    product_setSelected(product_options);
    const agent_map = _rows.map((key) => key.agent);
    const agent_unique = [...new Set(agent_map)];
    const agent_options = agent_unique.map((key) => ({
      label: key,
      value: key,
    }));
    agent_setSelected(agent_options);
    const task_map = _rows.map((key) => key.task);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key.toUpperCase(), value: key }));
    task_setSelected(task_options);
  }, [_rows]);

  const raw = _rows
    .filter((row) => row?.file !== "NO")
    .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    .filter((row) => product_selected.map((row) => row.value).includes(row.product))
    .filter((row) => task_selected.map((row) => row.value).includes(row.task))

    .filter((row) => agent_selected.map((row) => row.value).includes(row.agent));
  return (
    <>
      {isOpen && <Lightbox image={isOpen} onClose={() => setImage(null)} />}
      <Card className="p-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
        <Container fluid>
          <div className="col-6 w-100 justify-content-end d-flex ">
            <h1>
              ALBUM
            </h1>
          </div>
          <br />
          <div className="card p-2 shadow-sm pb-5 px-4">
            <h4 className="text-muted">Filters Criteria</h4>
            <Row>
              <Col>
                <label>Select POS</label>
                <MultiSelect
                  name="pos"
                  options={pos_options}
                  value={pos_selected}
                  onChange={pos_setSelected}
                  labelledBy={"Select POS"}
                />
              </Col>
              <Col>
                <label>Select Rounds</label>
                <MultiSelect
                  name="round"
                  options={round_options}
                  value={round_selected}
                  onChange={round_setSelected}
                  labelledBy={"Select Round"}
                />
              </Col>
              <Col>
                <label>Select Products</label>
                <MultiSelect
                  name="product"
                  options={product_options}
                  value={product_selected}
                  onChange={product_setSelected}
                  labelledBy={"Select Product"}
                />
              </Col>
              <Col>
                <label>Select Users</label>
                <MultiSelect
                  name="user"
                  options={agent_options}
                  value={agent_selected}
                  onChange={agent_setSelected}
                  labelledBy={"Select User"}
                />
              </Col>
              <Col>
                <label>Select Tasks</label>
                <MultiSelect
                  name="task"
                  options={task_options}
                  value={task_selected}
                  onChange={task_setSelected}
                  labelledBy={"Select Taks"}
                />
              </Col>
            </Row>
          </div>
          <br />

          <br />
          {!props.queryng ? (
            <Row className="mt-5">
              {raw.map((row, key) => {
                const date = row.write + " " + row.write_time
                return (
                  <Col xs={3} key={key} style={{ minHeight: "375px" }}>
                    <Card className="p-2 ">
                      <Row className="d-flex justify-content-center w-100 text-center">
                        <Col xs={12}>
                          <img
                            alt="product"
                            className="image-fluid rounded cursor-pointer margin-auto"
                            height="150px"
                            onClick={() => setImage(row.image)}
                            width="150px"
                            src={row.image}
                          />
                        </Col>

                        <Col>
                          {row.product ?
                            <>
                              <small className="text-muted">PRODUCT:</small>
                              <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                {row.product}
                              </p>
                            </> :
                            <>
                              <small className="text-muted">ACTION:</small>
                              <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                {row.task.toUpperCase()}
                              </p>
                            </>}
                          <small className="text-muted">POS:</small>
                          <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                            {row.pos}
                          </p>
                          <small className="text-muted">TASK:</small>
                          {row.product ? <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                            {row.task}
                          </p> : null}

                          {row.comment ? <>
                            <small className="text-muted">COMMENT:</small>
                            <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                              {row.comment}
                            </p> </> : null}
                          <small className="text-muted">Date/Time:</small>
                          <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                            {date}
                          </p>
                        </Col>
                      </Row>
                    </Card>
                    <br />
                  </Col>
                );
              })}
            </Row>
          ) : (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}
        </Container>
      </Card>
    </>
  );
}